import * as ReactGA from 'react-ga';

const GA_QA = 'UA-96382331-25';
const GA_PROD = 'UA-96382331-23';

export const initGA = () => {
  const GA_ID: string =
    location.hostname.indexOf('marquee.gs.com') > -1 ||
    location.hostname.indexOf('marquee.web.gs.com') > -1
      ? GA_PROD
      : GA_QA;

  ReactGA.initialize(GA_ID);
  const ga = ReactGA.ga();
  // The following options are taken from google analytics
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference
  ga('set', 'forceSSL', true);
  ga('set', 'transport', 'beacon');
};

// Log a page view once GA has been initialized
export const logGAPageView = () => {
  if (typeof ReactGA !== 'undefined') {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
};
